export let Data = [
  {
    id: 0,
    title: 'Demon Slayer - Infinity Train',
    posterUrl: 'https://www.telerama.fr/sites/tr_master/files/sheet_media/movie/7_3327749.jpg',
    description: 'The heroes of the Demon Slayer series, Tanjiro, Nezuko, Inosuke and Zenitsu, have finished their recovery training at the Butterfly Domain and are sent on a mission aboard the Infinity Train to eliminate a demon that has claimed more than forty victims in a short period of time.',
    rating: 9,
    trailer: "https://www.youtube.com/embed/bFwdl2PDAFM",
  },
  {
    id: 1,
    title: 'The Wolf of Wall Street',
    posterUrl: 'https://itti.hypotheses.org/files/2020/03/Image1.png',
    description: 'The film is inspired by a true story. It tells the story of Jordan Belfort, an American stockbroker. The film traces the rise of this man in the 1980s. Starting at L.F. Rothschild on Wall Street, he learned the first secrets of Wall Street "putting clients, money in your pocket". He also learnt the need to be relaxed and to do this through drugs, sex ...',
    rating: 8,
    trailer: 'https://www.youtube.com/embed/iszwuX1AK6A',
  },
  {
    id: 2,
    title: 'American Gangster',
    posterUrl: 'https://cdn.shopify.com/s/files/1/0440/1083/2027/products/american-gangster-poster_1024x1024.jpg?v=1605716481',
    description: 'An outcast New York City cop is charged with bringing down Harlem drug lord Frank Lucas, whose real life inspired this partly biographical film. Following the death of his employer and mentor, Bumpy Johnson, Frank Lucas establishes himself as the number one importer of heroin in the Harlem district of Manhattan.',
    rating: 7,
    trailer: 'https://www.youtube.com/embed/BV_nssS6Zkg',
  },

]